import config from './config';

export default (state = config, { type }: { type: string }) => {
    switch (type) {
        default:
            return state;
    }
};
